import React from 'react'
import { TableSkeleton, type TableSkeletonColumn } from '@components/ui'
import './ClaimsSkeleton.css'

type ClaimsSkeletonVariant = 'claims' | 'tracking'

const CLAIMS_COLUMNS: TableSkeletonColumn[] = [
  { width: '14%', kind: 'text' },
  { width: '12%', kind: 'text' },
  { width: '16%', kind: 'text' },
  { width: '16%', kind: 'text' },
  { width: '10%', kind: 'text' },
  { width: '10%', kind: 'text' },
  { width: '12%', kind: 'badge' },
  { width: '10%', kind: 'actions' },
]

const TRACKING_COLUMNS: TableSkeletonColumn[] = [
  { width: '28px', kind: 'spacer' },
  { width: '11%', kind: 'text' },
  { width: '13%', kind: 'text' },
  { width: '14%', kind: 'text' },
  { width: '9%', kind: 'text' },
  { width: '9%', kind: 'text' },
  { width: '9%', kind: 'text' },
  { width: '9%', kind: 'text' },
  { width: '8%', kind: 'text' },
  { width: '9%', kind: 'badge' },
  { width: '10%', kind: 'actions' },
]

interface SkeletonProps {
  rows?: number
  hideHeader?: boolean
  variant?: ClaimsSkeletonVariant
}

const ClaimsSkeleton: React.FC<SkeletonProps> = ({
  rows = 8,
  hideHeader = false,
  variant = 'claims',
}) => (
  <div
    className={`claims-skeleton full-page${
      hideHeader ? ' claims-skeleton--tab' : ''
    }${variant === 'tracking' ? ' claims-skeleton--tracking' : ''}`}
    aria-hidden="true"
  >
    {variant === 'tracking' ? (
      <div className="claims-skeleton-metrics">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={`metric-${index}`} className="claims-skeleton-metric">
            <span className="claims-skeleton-metric-title" />
            <span className="claims-skeleton-metric-value" />
            <span className="claims-skeleton-metric-date" />
          </div>
        ))}
      </div>
    ) : null}
    <TableSkeleton
      columns={variant === 'tracking' ? TRACKING_COLUMNS : CLAIMS_COLUMNS}
      rows={rows}
      showToolbar={!hideHeader}
      showPagination
    />
  </div>
)

export default ClaimsSkeleton
